import { clientConfig } from '@/store'
import type { BrandingConfig, ThemeConfig } from '@/config/types'

export function applyTheme(theme: ThemeConfig, branding: BrandingConfig): void {
  const root = document.documentElement

  root.style.setProperty('--color-background', theme.backgroundColor)
  root.style.setProperty('--color-primary', theme.primaryColor)
  root.style.setProperty('--color-accent', theme.accentColor)
  root.style.setProperty('--color-text', theme.textColor)
  root.style.setProperty('--color-surface', theme.surfaceColor)

  root.style.setProperty('--logo-max-width', `${branding.logoMaxWidth}px`)
  root.style.setProperty('--logo-max-height', `${branding.logoMaxHeight}px`)

  if (branding.backgroundImageUrl) {
    root.style.setProperty('--bg-image', `url(${branding.backgroundImageUrl})`)
  } else {
    root.style.removeProperty('--bg-image')
  }

  const adBackdrop = clientConfig.adBackdropUrl
  root.style.setProperty('--ad-bg-image', adBackdrop ? `url(${adBackdrop})` : 'none')
}
